export default "__VITE_ASSET__6JR8KswT__"